import React from 'react';
import './Home.css'
import { HashLink } from 'react-router-hash-link';

function Home() {
    return (
        <React.Fragment>
            <div className='hero-banner'>
                <div className='hero-image'>
                    <img src='/imgs/hero-image.webp' className="mx-auto d-block" alt="Home Page" loading='lazy' />
                </div>

                <div className='hero-text text-center text-white'>
                    <p className='main-text'> Coastal. Marine. Offshore. </p>
                    <p className='sub-text'> Engineering and Modelling Specialists </p>
                </div>

                <div className='hero-info'>
                    <HashLink smooth to="/expertise#coastal-engineering" style={{textDecoration: "none"}}>
                        <div className='hero-card'> <p> Coastal Engineering </p> </div>
                    </HashLink>

                    <HashLink smooth to="/expertise#maritime-structures" style={{textDecoration: "none"}}>
                        <div className='hero-card'> <p> Maritime Structures </p> </div>
                    </HashLink>

                    <HashLink smooth to="/expertise#numerical-modelling" style={{textDecoration: "none"}}>
                        <div className='hero-card'> <p> Numerical Modelling </p> </div>
                    </HashLink>

                    <HashLink smooth to="/expertise#hydrotechnical-engineering" style={{textDecoration: "none"}}>
                        <div className='hero-card'> <p> Hydrotechnical Engineering </p> </div>
                    </HashLink>    
                </div>
            </div>

            <div className='container my-5'>
                <div className='about-us'>
                    <h3 className='section-title text-center'> About Us </h3>
                    <p className='about-us-info'> We provide customers with innovative solutions for port development, coastal, hydrotechnical and waterfront projects. Specializing in coastal engineering, we are able to offer a variety of engineering services and effective business solutions on the basis of a range of sophisticated computer simulations, in-depth data analysis, and application of economic and risk analyses tools. </p>
                    <br />
                    <p className='about-us-info'> We use a range of techniques, numerical models and specialized software to develop a thorough understanding of the governing processes at the project site. We use this information to maximize performance and value in the design of many types of marine structures and foreshore developments. </p>
                </div>
            </div>

            <div className='our-services'>
                <h3 className='section-title text-center'> Our Services </h3>
                <div className='services-grid'>
                    <HashLink smooth to='/services#nature-based-solutions'>
                        <div className='services-card'>
                            <img src='/imgs/shoreline-protection.webp' alt='Natured-Based Solutions' loading='lazy' />
                            <p className='card-label'> Nature-Based Solutions </p>
                            <p className='arrow'> → </p>
                        </div>
                    </HashLink>

                    <HashLink to='/services#harbour-breakwater-design'>
                        <div className='services-card'>
                            <img src='/imgs/harbour-breakwater-1.webp' alt='Harbour and Breakwater Design' loading='lazy' />
                            <p className='card-label'> Harbour and Breakwater Design </p>
                            <p className='arrow'> → </p>
                        </div>
                    </HashLink>

                    <HashLink to='/services#outfall-environmental-modelling'>
                        <div className='services-card'>
                            <img src='/imgs/home-outfall-modelling.webp' alt='Outfall Modelling' loading='lazy' />
                            <p className='card-label'> Outfall and Environmental Modelling </p>
                            <p className='arrow'> → </p>
                        </div>
                    </HashLink>

                    <HashLink to='/services#mooring-analysis-design'>
                        <div className='services-card'>
                            <img src='/imgs/home-mooring.webp' alt='Mooring Analysis and Design' loading='lazy' />
                            <p className='card-label'> Mooring Analysis and Design </p>
                            <p className='arrow'> → </p>
                        </div>
                    </HashLink>

                    <HashLink to='/services#sediment-transport-morphological-analysis'>
                        <div className='services-card'>
                            <img src='/imgs/sediment-transport-2.webp' alt='Sediment Transport' loading='lazy' />
                            <p className='card-label'> Sediment Transport and Morphological Analysis </p>
                            <p className='arrow'> → </p>
                        </div>
                    </HashLink>

                    <HashLink to='/services#flood-hazard-analysis'>
                        <div className='services-card'>
                            <img src='/imgs/flood-hazard-analysis-1.webp' alt='Flood Hazard Analysis' loading='lazy' />
                            <p className='card-label'> Flood Hazard Analysis </p>
                            <p className='arrow'> → </p>
                        </div>
                    </HashLink>

                    <HashLink to='/services#arctic-engineering'>
                        <div className='services-card'>
                            <img src='/imgs/home-arctic-engineering.webp' alt='Arctic Engineering' loading='lazy' />
                            <p className='card-label'> Arctic Engineering </p>
                            <p className='arrow'> → </p>
                        </div>
                    </HashLink>

                    <HashLink to='/services#metocean-analysis-modelling'>
                        <div className='services-card'>
                            <img src='/imgs/metocean-analysis-1.webp' alt='Metocean Analysis' loading='lazy' />
                            <p className='card-label'> Metocean Analysis and Modelling </p>
                            <p className='arrow'> → </p>
                        </div>
                    </HashLink>

                    <HashLink to='/services#marine-float-design'>
                        <div className='services-card'>
                            <img src='/imgs/home-marina.webp' alt='Marine and Float Design' loading='lazy' />
                            <p className='card-label'> Marine and Float Design </p>
                            <p className='arrow'> → </p>
                        </div>
                    </HashLink>

                </div>
            </div>
        </React.Fragment>
    )
}

export default Home;